import { OrganizationTreePopover } from 'components/OrganizationTreePopover';
import type { ObjectManagerDetailProps } from '../ObjectManagerDetail';

const Organizations = ({ object, onChange }: ObjectManagerDetailProps) => {
  return (
    <OrganizationTreePopover
      title="Organizations"
      value={object.organizations || []}
      onChange={(val) => onChange({ organizations: val as string[] })}
    />
  );
};

export default Organizations;
